import { ISelectOption } from './selectOption.interface';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { Label } from 'src/app/labels/englishLabels';

export const EventDrivenSupportSelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.EventDrivenSupport}-true`,
    value: 'true',
    displayName: Label.get('common.true'),
    categoryName: FilterTypesEnum.EventDrivenSupport.toString(),
    filterType: FilterTypesEnum.EventDrivenSupport,
  },
  {
    id: `${FilterTypesEnum.EventDrivenSupport}-false`,
    value: 'false',
    displayName: Label.get('common.false'),
    categoryName: FilterTypesEnum.EventDrivenSupport.toString(),
    filterType: FilterTypesEnum.EventDrivenSupport,
  },
];
